var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"color":_vm.chipColor(_vm.params.value)[0]}},[_vm._v(_vm._s(_vm.chipColor(_vm.params.value)[1]))])}
var staticRenderFns = []

export { render, staticRenderFns }